<template>
  <div class="d-flex align-items-center justify-content-center">
    <!-- START : Product Image -->
    <div>
      <router-link
        v-if="!scanMode"
        :to="`/i/${item.id}`"
        class="wc-list__image-link"
        :aria-label="item.name"
      >
        <WCImage
          :imageSrc="getProductImage(item.image, 100)"
          :imageAlt="$t('productDescImgAltText', { name: item.name })"
          imageClass="wc-image-wrapper mx-auto"
          defaultClass="wc-icon-wrapper"
          :defaultTitle="noProductImageAltText(item.name)"
        />
      </router-link>
      <WCImage
        v-else
        :imageSrc="getProductImage(item.image, 100)"
        :imageAlt="$t('productDescImgAltText', { name: item.name })"
        imageClass="wc-image-wrapper mx-auto"
        defaultClass="wc-icon-wrapper"
        :defaultTitle="noProductImageAltText(item.name)"
      />
    </div>
    <!-- END : Product Image -->
  </div>
</template>
<script>
import WCImage from '@/components/WCImage/WCImage.vue';
import ProductImageInfoMixin from '../../../../mixins/ProductImageInfoMixin';

export default {
  name: 'WCProductDetailsImage',
  props: {
    item: {
      type: Object,
      required: true,
    },
    scanMode: {
      type: Boolean,
      default: false,
    },
  },
  components: { WCImage },
  mixins: [ProductImageInfoMixin],
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-icon-wrapper {
  font-size: $font-size-6xl;
  @include media-breakpoint-down(sm) {
    font-size: $font-size-5xl;
  }
}

.wc-image-wrapper {
  max-width: rem(100px);
  max-height: rem(100px);
  object-fit: contain;
  @include media-breakpoint-only(xs) {
    max-width: rem(60px);
    max-height: rem(60px);
  }

  @include media-breakpoint-only(sm) {
    width: rem(80px);
    height: rem(80px);
  }
}
</style>
